import { createTheme, responsiveFontSizes  } from '@material-ui/core/styles';

export const mainColor = '#bdd739';
export const mainLightColor = '#ddf769';
// Dark olive of mainColor for the pending-score outline: 3.25:1 or more on every page
// background even at the pending style's 60% opacity (WCAG non-text contrast).
export const mainDarkColor = '#333d0d';
export const borderColor = '#ddd';
export const borderRadius = '4px';

export const backgroundColor = '#fafcfe';
export const sectionColor = '#f0f4f9';
export const sectionDarkColor = '#e0e4e9';
export const sectionDarkerColor = '#d0d4d9';

export const dangerColor = '#ed4337';
export const dangerColorLight = '#ed5347';
// Highlight fill behind unknown/stale/split-token marks and chips. Text on it:
// dangerTextColor 5.4:1, near-black body text 17:1 (both WCAG AA).
export const dangerHighlightColor = '#fde3e1';
// Dark red for danger TEXT on light/highlight fills — dangerColor (#ed4337) only
// reaches ~3.2:1 there. 6.5:1 on #fff, 5.4:1 on dangerHighlightColor (WCAG AA).
export const dangerTextColor = '#b3261e';
export const warnColor = '#ffcf33';
export const warnColorLight = '#ffdf43';
// Burnt orange for warning TEXT on light backgrounds — alerting, and unlike the
// warnColor (#ffcf33) fill it stays legible as text. ~5.5:1 on #fff (WCAG AA).
export const warnTextColor = '#b34700';
// Highlight fill behind needs-a-default token marks and chips. Text on it:
// warnTextColor 4.7:1, near-black body text 17:1 (both WCAG AA).
export const warnHighlightColor = '#ffe9d6';
export const successColor = '#4bb543';
export const infoColor = '#59a6f2';
// Muted grey for neutral/skipped chip fills — white text ~5:1 (WCAG AA); the
// former #999 was ~2.85:1.
export const neutralColor = '#6e6e6e';
// Muted text — a lighter tint of body copy on light fills. 7.5:1 on #fff, 6.4:1 on #eee (WCAG AA).
export const mutedTextColor = '#444444';

const theme = createTheme({
  palette: {
    primary: {
      main: mainColor,
      light: '#A2DEAA',
    },
    secondary: { main: '#43C2C1' },
  },
  typography: {
    fontFamily: ['Quicksand', 'sans-serif'].join(',')
  }
});

export default responsiveFontSizes(theme);
